import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import {
  memo,
  useEffect,
  useRef,
  useState
} from 'react';
import Loader from 'src/common/Loader';
import { APIService } from 'src/api/api';
import ReactECharts from 'src/common/ReactECharts';
import ROUTE from 'src/utils/routeConstants';
import { getVehicleStatusChartConfig } from './chartConfig';
import { getVehicleStatusList } from './chartService';

const VehicleStatusChart = ({ sx, ...props }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [usageData, setUsageData] = useState(null);
  const [vehicleList, setVehicleList] = useState(null);
  const isMountedRef = useRef(false);
  const requestIdRef = useRef(0);

  const formatToEChartData = (status) => {
    const data = [
      { value: status.breakdown?.length, name: 'Breakdown' },
      { value: status.active?.length, name: 'Engage' },
      { value: status.inactive?.length, name: 'Idle' },
    ];
    const chartData = getVehicleStatusChartConfig(data);
    setUsageData(chartData);
  };

  const fetchChartData = async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    if (isMountedRef.current) {
      setLoading(true);
    }

    try {
      const res = await APIService.getVehicleStatus();
      if (!isMountedRef.current || requestId !== requestIdRef.current) {
        return;
      }

      if (!res.success) throw res;
      setVehicleList(res.result);
      formatToEChartData(res.result);
    } catch (error) {
      if (!isMountedRef.current || requestId !== requestIdRef.current) {
        return;
      }

      console.log('vehicle status error', error.message);
    } finally {
      if (isMountedRef.current && requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    fetchChartData();
  }, []);

  const onChartClick = (chartData) => {
    console.log(chartData);
    const vehicleData = getVehicleStatusList(vehicleList, chartData);
    history.push(ROUTE.vehicleStatusList, vehicleData);
  };

  const onEvents = {
    click: onChartClick,
  };

  return (
    <Card
      {...props}
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx
      }}
    >
      <CardHeader
        title="Vehicle Running Status"
        sx={{
          backgroundColor: '#fff',
          color: '#111827'
        }}
      />
      <Divider />
      <CardContent sx={{ px: 0, flex: 1 }}>
        <Box sx={{ height: 400, position: 'relative' }}>
          {loading || !usageData ? (
            <Loader />
          ) : (
            <ReactECharts options={usageData} onEvents={onEvents} />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default memo(VehicleStatusChart);

VehicleStatusChart.propTypes = {
  sx: PropTypes.object
};
